module.exports = __webpack_public_path__ + "img/grouped_results.232863b6.svg";